import { PaymentMethod, PaymentSource } from '../../../pure-js/types/GrooverTypes'
import { getGrooverText } from '../libs/GrooverTextRepository'

export function getPaymentMethodLabel(method: PaymentMethod | string): string {
  switch (method) {
    case PaymentMethod.Cash:
    case 'Cash':
      return getGrooverText('paymentMethod.cash')
    case PaymentSource.SwishWalkIn:
    case 'swish_walkin':
      return getGrooverText('paymentMethod.swishWalkIn')
    case PaymentSource.StripeTerminal:
    case 'stripe_terminal':
      return getGrooverText('paymentMethod.stripeTerminal')
    case PaymentMethod.Swish:
    case 'Swish':
    case 'swish':
      return getGrooverText('paymentMethod.swish')
    case PaymentMethod.SwishManual:
    case 'SwishManual':
      return getGrooverText('paymentMethod.swishManual')
    case PaymentMethod.ManualCard:
    case 'ManualCard':
      return getGrooverText('paymentMethod.manualCard')
    case PaymentMethod.BankTransfer:
    case 'BankTransfer':
      return getGrooverText('paymentMethod.bank')
    case PaymentMethod.Stripe:
    case PaymentMethod.StripeDropin:
    case 'Stripe':
    case 'StripeDropin':
    case 'stripe':
      return getGrooverText('paymentMethod.card')
    case PaymentMethod.StripePrivateLesson:
    case 'StripePrivateLesson':
      return getGrooverText('paymentMethod.stripePrivateLesson')
    case PaymentMethod.VippsMobile:
    case 'VippsMobile':
      return getGrooverText('paymentMethod.vipps')
    case PaymentMethod.VippsMobileManual:
    case 'VippsMobileManual':
      return getGrooverText('paymentMethod.vippsManual')
    case PaymentMethod.UserCredit:
    case 'UserCredit':
    case 'usercredit':
      return getGrooverText('paymentMethod.usercredit')
    case PaymentMethod.Epassi:
    case 'Epassi':
    case 'epassi':
      return getGrooverText('paymentMethod.epassi')
    case PaymentMethod.Fritidskortet:
    case 'Fritidskortet':
    case 'fritidskortet':
      return getGrooverText('paymentMethod.fritidskortet')
    case PaymentMethod.Manual:
    case 'manual':
      return getGrooverText('paymentMethod.manual')
    case PaymentMethod.Klarna:
    case 'Klarna':
      return getGrooverText('paymentMethod.card')
    case 'vipps':
      return getGrooverText('paymentMethod.vipps')
    default:
      return typeof method === 'string' ? method : getGrooverText('paymentMethod.manual')
  }
}
